import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as classNames from 'classnames';
import PriceDisplay from '../shared/price_display';
import { listingWithAdditionalParams } from './listing_with_aid';
import { MobileDetection } from '@reverbdotcom/discovery-ui';

const SOFTWARE_CATEGORY_UUID = 'e71b6e43-7217-4746-b4e3-64bf708a2664';

class Upsell extends React.Component {
  shouldShowTopPick() {
    return this.props.index === 0 && this.props.upsell.top_pick;
  }

  getMainImage() {
    if (!this.props.upsell.photos.length) return null;
    const links = this.props.upsell.photos[0]._links;

    if (MobileDetection.isMobileBrowser()) {
      return links.mobile_small.href;
    }

    return links.medium_square.href;
  }

  upsellWithParams() {
    return listingWithAdditionalParams(this.props.upsell, {
      _aid: this.props.aid,
      suggested_listing: true,
    });
  }

  upsellHref() {
    return this.upsellWithParams()._links.web.href;
  }

  get isDigitalListing() {
    return this.props.upsell.category_uuids.includes(SOFTWARE_CATEGORY_UUID);
  }

  renderAddToCartButton() {
    if (!this.props.addToCartButton) { return null; }

    const button = React.createElement(
      this.props.addToCartButton,
      {
        productId: this.upsellWithParams().id,
        aid: this.props.aid,
        suggestedListing: true,
      },
    );
    return button;
  }

  renderTopPick() {
    if (!this.shouldShowTopPick()) { return null; }

    return (
      <div className="upsell-card__top-pick">
        <span className="upsell-card__top-pick__logo" />
        {I18n.t('productShowPage.topPick')}
      </div>
    );
  }

  render() {
    const upsell = this.upsellWithParams();

    const classes = classNames('product-card', {
      'product-card--software': this.isDigitalListing,
    });

    return (
      <div className={classes}>
        <div className="product-card-img-container">
          <a href={this.upsellHref()}>
            <img alt={upsell.title} src={this.getMainImage()} />
          </a>
        </div>
        {this.renderTopPick()}
        <a href={this.upsellHref()}>
          <div className="product-card-description">
            <h4 className="product-card-body-sized">
              {upsell.title}
            </h4>
            <div className="price-footer">
              <div className="product-card__price">
                <PriceDisplay price={upsell.price} />
              </div>
            </div>
            <div className="product-card__action">
              {this.renderAddToCartButton()}
            </div>
          </div>
        </a>
      </div>
    );
  }
}

Upsell.propTypes = {
  upsell: PropTypes.object.isRequired,
  addToCartButton: PropTypes.func,
  aid: PropTypes.string,
  index: PropTypes.number,
};

Upsell.defaultProps = {
  aid: '',
};

export default Upsell;



// WEBPACK FOOTER //
// ./javascripts/components/product_show_page/upsell.jsx